export const STORE_MODULE_EXCHANGE = 'STORE_MODULE_EXCHANGE';

export const ACTION_GET_EXCHANGE_RATE_BY_CURRENCIES = 'ACTION_GET_EXCHANGE_RATE_BY_CURRENCIES';
